"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSDKAdapter = void 0;
var NoEditorSDKProvidedForEditorSDKMode_1 = require("../../contexts/SettingsContext/NoEditorSDKProvidedForEditorSDKMode");
var editorSDKAdapter_1 = require("./editorSDKAdapter");
var wixSDKAdapter_1 = require("./wixSDKAdapter");
function createSDKAdapter(_a) {
    var componentRef = _a.componentRef, WixSDK = _a.WixSDK, editorSDK = _a.editorSDK;
    if (componentRef) {
        if (!editorSDK) {
            throw new NoEditorSDKProvidedForEditorSDKMode_1.NoEditorSDKProvidedForEditorSDKMode();
        }
        return editorSDKAdapter_1.createEditorSDKAdapter(editorSDK, componentRef);
    }
    return wixSDKAdapter_1.createWixSDKAdapter(WixSDK);
}
exports.createSDKAdapter = createSDKAdapter;
//# sourceMappingURL=sdk.js.map